import { resourceStore } from '../resourceStore';
import { createStoreDispatcher, type StoreDispatcher } from '../../commands/storeDispatcher';
import type { ResourceCommand } from './resourceCommands';

let dispatcher: StoreDispatcher<ResourceCommand> | null = null;
let initialized = false;

export function initResourceDispatcher(): StoreDispatcher<ResourceCommand> {
  if (initialized) return dispatcher!;
  initialized = true;
  dispatcher = createStoreDispatcher<ResourceCommand>(resourceStore);
  return dispatcher;
}

export function getResourceDispatcher(): StoreDispatcher<ResourceCommand> {
  if (!dispatcher) {
    throw new Error('Resource dispatcher not initialized. Call initResourceDispatcher() first.');
  }
  return dispatcher;
}
